import React, { FunctionComponent } from 'react';
import { connect, ResolveThunks } from 'react-redux';

import { AnalysisSettings } from '@paragon/contract-library';

import { RootState } from '../../../../../store';
import { updateInsertingTrussFromSettings } from '../../../../../store/actions/insertComponentDesignActions';
import { loadAnalysisSettings } from '../../../../../store/actions/loadActions';
import { saveAnalysisSettings } from '../../../../../store/actions/settingsActions';
import { settingsShouldBeViewOnly } from '../../../../../store/selectors/viewOnlyModeSelectors';
import {
  InsertingComponentDesignInfo,
  setInsertionAnalysisSettings,
} from '../../../../../store/slices/applicationSlice';
import SettingsPanelContainer, { connectSettingsPanelContainer } from '../SettingsPanelContainer';
import { SingleAnalysisSettingsControls } from './AnalysisSettingsControls';

const AnalysisSettingsPanelContainer = connectSettingsPanelContainer(
  class extends SettingsPanelContainer<AnalysisSettings> {},
);

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

const AnalysisSettingsPanel: FunctionComponent<Props> = (props) => (
  <AnalysisSettingsPanelContainer
    isViewOnly={props.viewOnly}
    controls={SingleAnalysisSettingsControls}
    fetchSettings={{
      fromInsertionInfo: (insertionInfo: InsertingComponentDesignInfo) => insertionInfo.analysisSettings,
      fromSettingsDatabase: props.loadAnalysisSettings,
    }}
    onSave={{
      forInsertionComponent: async (settings) => {
        props.setInsertionAnalysisSettings({ settings, state: 'modified' });
        await props.updateInsertingTrussFromSettings({ preview: true });
      },
      forExistingModel: props.saveAnalysisSettings,
    }}
  />
);

const mapStateToProps = (state: RootState) => ({
  viewOnly: settingsShouldBeViewOnly(state),
});

const actionCreators = {
  loadAnalysisSettings,
  saveAnalysisSettings,
  setInsertionAnalysisSettings,
  updateInsertingTrussFromSettings,
};

export default connect(mapStateToProps, actionCreators)(AnalysisSettingsPanel);
